// extracted by mini-css-extract-plugin
export default {"iapTYText":"o74-RvSL","iapTYH1":"_2cbIEE_M","iapTYContent":"_3JyyU5GO"};